export const Flow = Object.freeze({
  CHAT: 'chat',
  VIDEO: 'video',
  DEAL: 'deal',
  HYFY_MIGRATION: 'hyfy-migration'
})

export const MeetingsSetupOrder = [
  'setup/profile',
  'setup/password',
  'setup/meetings',
  'setup/extension',
]

export const TouchlessSetupOrder = [
  'start',
  'setup/touchless/custom',
  'setup/touchless/welcome',
  'setup/touchless/details',
  'setup/touchless/install',
]

export const CalendarSeatSetupOrder = [
  'setup/calendaring/activate',
  'setup/calendaring/profile',
  'setup/calendaring/connect',
  'setup/calendaring/select',
  // 'setup/calendaring/extension',
  'setup/calendaring/hooray',
]



// WEBPACK FOOTER //
// ./src/constants/flowConstants.js